import React from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {labels} from '../../../../../../../util/utils';
import {entities, itControlApproachType, promiseAreas} from '../../../../../../../util/uiconstants';
import {useEngagementId} from '../../../../../../../util/customHooks';
import {getAllItControls} from '../../../../../../../actions/ITControl/itcontrolaction';
import BodySpecialToolbarButton from '../BodySpecialToolbarButton';
import ItProcessUnrelatedItGcCount from '../ISA315ItProcessItRiskBody/ItProcessUnrelatedItGcCount';

function ISA315ManageITSPToolbar({label, entityId, bodyId, itApproachTypeId, openViewModal}) {
	const engagementId = useEngagementId();
	const dispatch = useDispatch();

	const updateUnrelatedItSpCount = () => {
		return dispatch(
			getAllItControls(
				engagementId,
				{
					IsUnrelated: true,
					ITApproachTypeId: itControlApproachType.substantive
				},
				{bodyId, metadataKey: 'unrelatedItControls'},
				promiseAreas.ITPROCESS_UNRELATED_ITGC_COUNT
			)
		);
	};

	const viewUnrelatedItControls = (itControlIdsSelector) => {
		openViewModal({
			entityId: entities.ItControl,
			showUnrelatedITSP: true,
			allIdsSelector: itControlIdsSelector,
			bodyId: bodyId,
			modalTitle: labels.manageITSPUnrelatedITSPUppercase,
			modalDescription: labels.unrelatedITSPModalMessage,
			onModalHide: updateUnrelatedItSpCount
		});
	};
	return (
		<StyledISA315ManageITSPToolbar>
			<ItProcessUnrelatedItGcCount
				showUnrelatedITSP
				bodyId={bodyId}
				className="unrelated-itgc-container"
				onCountClick={viewUnrelatedItControls}
			/>
			<BodySpecialToolbarButton label={label} entityId={entityId} bodyId={bodyId} itApproachTypeId={itApproachTypeId} />
		</StyledISA315ManageITSPToolbar>
	);
}

const StyledISA315ManageITSPToolbar = styled.section`
	display: flex;
	align-items: flex-end;
	width: 100%;
	.unrelated-itgc-container {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		margin-right: var(--px-80);
	}
`;

ISA315ManageITSPToolbar.propTypes = {
	buttonLabel: PropTypes.string,
	entityId: PropTypes.number,
	bodyId: PropTypes.number
};

export default ISA315ManageITSPToolbar;
